module.exports = __webpack_public_path__ + "img/full6-min.158e5df2.png";